import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import TipPageV3 from "./pages/tip/TipPageV3";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPayoutManagement from "./pages/admin/AdminPayoutManagement";
import PayoutPage from "./pages/admin/PayoutPage";
import EmployeeDashboard from "./pages/employee/EmployeeDashboardV2";
import AdminBusinessDashboard from "./pages/admin/AdminBusinessDashboard";
import AdminEmployeeDashboard from "./pages/admin/AdminEmployeeDashboard";
import AdminBusinessesPage from "./pages/admin/AdminBusinessesPage";
import {AuthProvider} from "./context/AuthProvider";
import PrivateRoute from "./components/PrivateRoute";
import LoginPage from "./pages/LoginPage";
import AdminOnlyRoute from "./components/AdminOnlyRoute";
import LandingPageV3 from "./pages/LandingPageV3";
import BusinessDashboardPage from "./pages/business/BusinessDashboardPageV2";
import BusinessInformation from "./pages/business/BusinessInformationV2";
import BusinessPayouts from "./pages/business/BusinessPayoutsV2";
import BusinessPendingPayouts from "./pages/business/BusinessPendingPayouts";
import BusinessTips from "./pages/business/BusinessTipsV2";
import BusinessEmployees from "./pages/business/BusinessEmployeesV2";
import BusinessEmployeeDashboard from "./pages/business/BusinessEmployeeDashboardV2";
import BusinessEmployeeInformation from "./pages/business/BusinessEmployeeInformationV2";
import BusinessStatistics from "./pages/business/BusinessStatisticsV2";
import BusinessEmployeeTips from "./pages/business/BusinessEmployeeTipsV2";
import BusinessEmployeePayouts from "./pages/business/BusinessEmployeePayoutsV2";
import EmployeeRoute from "./components/EmployeeRoute";
import EmployeeInformation from "./pages/employee/EmployeeInformationV2";
import EmployeePayouts from "./pages/employee/EmployeePayoutsV2";
import EmployeeTips from "./pages/employee/EmployeeTipsV2";
import TipSuccessPageV3 from "./pages/tip/TipSuccessPageV3";
import BusinessSignupPage from "./pages/BusinessSignup";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import BusinessConfigurationPage from "./pages/business/BusinessConfigurationPage";
import BusinessShiftPage from "./pages/business/BusinessShiftPage";
import ReferralPage from "./pages/ReferralPage";
import SupportedCountriesPage from "./pages/SupportedCountriesPage";
import SelectVenuePage from "./pages/SelectVenuePage";
import AuthenticatedRoute from "./components/AuthenticatedRoute";

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<LandingPageV3 locale="en"/>}/>
                    <Route path="/es" element={<LandingPageV3 locale="es"/>}/>
                    <Route path="/fi" element={<LandingPageV3 locale="fi"/>}/>
                    <Route path="/fr" element={<LandingPageV3 locale="fr"/>}/>
                    <Route path="/it" element={<LandingPageV3 locale="it"/>}/>
                    <Route path="/pt" element={<LandingPageV3 locale="pt"/>}/>
                    <Route path="/de" element={<LandingPageV3 locale="de"/>}/>
                    <Route path="/supported-countries" element={<SupportedCountriesPage/>}/>

                    <Route path="/referral" element={<ReferralPage/>}/>
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="/select-venue" element={
                        <AuthenticatedRoute><SelectVenuePage/></AuthenticatedRoute>
                    }/>
                    <Route path="/privacy" element={<PrivacyPolicyPage/>}/>
                    <Route path="/terms" element={<TermsOfUsePage/>}/>

                    {/* Protected for Business Owner */}
                    <Route path="/business/dashboard" element={
                        // <PrivateRoute><BusinessDashboard /></PrivateRoute>
                        <PrivateRoute><BusinessDashboardPage/></PrivateRoute>
                    }/>
                    <Route path="/business/information" element={
                        // <PrivateRoute><BusinessDashboard /></PrivateRoute>
                        <PrivateRoute><BusinessInformation/></PrivateRoute>
                    }/>
                    <Route path="/business/configuration" element={
                        // <PrivateRoute><BusinessDashboard /></PrivateRoute>
                        <PrivateRoute><BusinessConfigurationPage/></PrivateRoute>
                    }/>
                    <Route path="/business/shifts" element={
                        // <PrivateRoute><BusinessDashboard /></PrivateRoute>
                        <PrivateRoute><BusinessShiftPage/></PrivateRoute>
                    }/>
                    <Route path="/business/payouts" element={
                        // <PrivateRoute><BusinessPayoutsPage /></PrivateRoute>
                        <PrivateRoute><BusinessPayouts/></PrivateRoute>
                    }/>
                    <Route path="/business/pendingPayouts" element={
                        // <PrivateRoute><BusinessPayoutsPage /></PrivateRoute>
                        <PrivateRoute><BusinessPendingPayouts/></PrivateRoute>
                    }/>
                    <Route path="/business/tips" element={
                        // <PrivateRoute><BusinessPayoutsPage /></PrivateRoute>
                        <PrivateRoute><BusinessTips/></PrivateRoute>
                    }/>
                    <Route path="/business/statistics" element={
                        // <PrivateRoute><AnalyticsStatisticsPage /></PrivateRoute>
                        <PrivateRoute><BusinessStatistics/></PrivateRoute>
                    }/>
                    <Route path="/business/employees" element={
                        // <PrivateRoute><AnalyticsStatisticsPage /></PrivateRoute>
                        <PrivateRoute><BusinessEmployees/></PrivateRoute>
                    }/>
                    <Route path="/business/employee/:employeeID" element={
                        // <PrivateRoute><AnalyticsStatisticsPage /></PrivateRoute>
                        <PrivateRoute><BusinessEmployeeDashboard/></PrivateRoute>
                    }/>
                    <Route path="/business/employee/:employeeID/tips" element={
                        // <PrivateRoute><AnalyticsStatisticsPage /></PrivateRoute>
                        <PrivateRoute><BusinessEmployeeTips/></PrivateRoute>
                    }/>
                    <Route path="/business/employee/:employeeID/payouts" element={
                        // <PrivateRoute><AnalyticsStatisticsPage /></PrivateRoute>
                        <PrivateRoute><BusinessEmployeePayouts/></PrivateRoute>
                    }/><Route path="/business/employee/:employeeID/information" element={
                    // <PrivateRoute><AnalyticsStatisticsPage /></PrivateRoute>
                    <PrivateRoute><BusinessEmployeeInformation/></PrivateRoute>
                }/>

                    <Route path="/profile/dashboard" element={
                        <EmployeeRoute><EmployeeDashboard/></EmployeeRoute>
                    }/>
                    <Route path="/profile/information" element={
                        <EmployeeRoute><EmployeeInformation/></EmployeeRoute>
                    }/>
                    <Route path="/profile/payouts" element={
                        <EmployeeRoute><EmployeePayouts/></EmployeeRoute>
                    }/>
                    <Route path="/profile/tips" element={
                        <EmployeeRoute><EmployeeTips/></EmployeeRoute>
                    }/>



                    {/*/!* 🔐 Employee page - accessible by employee or owner *!/*/}
                    {/*<Route path="/business/:businessID/employee/:employeeID" element={*/}
                    {/*    <EmployeeOrOwnerRoute><EmployeeDashboard/></EmployeeOrOwnerRoute>*/}
                    {/*}/>*/}
                    {/*<Route path="/business/:businessID/employee/:employeeID/payouts" element={*/}
                    {/*    <EmployeeOrOwnerRoute><EmployeePayoutsPage/></EmployeeOrOwnerRoute>*/}
                    {/*}/>*/}

                    {/* Public */}
                    <Route path="/tip/:businessID/:tipID" element={<TipPageV3/>}/>
                    <Route path="/tip/success/:orderID" element={<TipSuccessPageV3/>}/>
                    <Route path="/tip/success" element={<TipSuccessPageV3 />} />
                    <Route path="/signup" element={<BusinessSignupPage/>}/>

                    {/* 🔒 Admin-only */}
                    <Route path="/admin" element={<AdminOnlyRoute><AdminDashboard/></AdminOnlyRoute>}/>
                    <Route path="/admin/payouts" element={<AdminOnlyRoute><AdminPayoutManagement/></AdminOnlyRoute>}/>
                    <Route path="/admin/payouts/:payoutID" element={<AdminOnlyRoute><PayoutPage/></AdminOnlyRoute>}/>
                    <Route path="/admin/business" element={<AdminOnlyRoute><AdminBusinessesPage/></AdminOnlyRoute>}/>
                    <Route path="/admin/business/:businessID"
                           element={<AdminOnlyRoute><AdminBusinessDashboard/></AdminOnlyRoute>}/>
                    <Route path="/admin/business/:businessID/employee/:employeeID"
                           element={<AdminOnlyRoute><AdminEmployeeDashboard/></AdminOnlyRoute>}/>
                </Routes>


            </Router>
        </AuthProvider>
    );
}

export default App;
